import { getPeppolIdValue } from '~/app/forms/Customers/utils';
import { Calculation } from '../../../../../shared/components/Form/final-form-calculate';
import { SendElectronicInvoiceMethod } from '../book-and-send/types';

export function peppolIdUpdater(): Calculation[] {
    return [
        {
            field: 'eInvoiceOptions.cvr',
            updates: async (value, _, allValues: any) => {
                if (allValues?.eInvoiceOptions?.sendingMethod === SendElectronicInvoiceMethod.PeppolId) {
                    const peppolId = await getPeppolIdValue(allValues.eInvoiceOptions?.customerCountry, value);

                    return {
                        'eInvoiceOptions.peppolId': peppolId,
                    };
                }

                return {};
            },
        },
        {
            field: 'eInvoiceOptions.sendingMethod',
            updates: async (value, _, allValues: any) => {
                if (value === SendElectronicInvoiceMethod.PeppolId) {
                    const peppolId = await getPeppolIdValue(
                        allValues.eInvoiceOptions?.customerCountry,
                        allValues?.eInvoiceOptions?.cvr
                    );

                    return {
                        'eInvoiceOptions.peppolId': peppolId,
                    };
                }

                return {};
            },
        },
    ];
}
